export default annotations => window.documentViewer.getAnnotationManager().getNumberOfGroups(annotations);